import { alpha } from "@mui/material";

/**
 * Styling utilities for ScanQR dialog components
 */

/**
 * Get button styles for dialog actions
 * @param {Object} theme - MUI theme object
 * @param {string} variant - Button variant ('outlined' | 'contained')
 * @returns {Object} Button style object
 */
export const getDialogButtonStyles = (theme, variant = "outlined") => {
  const baseStyles = {
    borderRadius: "8px",
    textTransform: "none",
    py: 1,
    px: 2,
    fontWeight: 500,
  };

  if (variant === "outlined") {
    return {
      ...baseStyles,
      color:
        theme.palette.mode === "dark"
          ? "#00c9a7"
          : theme.palette.secondary.main,
      borderColor: alpha(
        theme.palette.mode === "dark"
          ? "#00c9a7"
          : theme.palette.secondary.main,
        0.5
      ),
      "&:hover": {
        borderColor:
          theme.palette.mode === "dark"
            ? "#00c9a7"
            : theme.palette.secondary.main,
        backgroundColor: alpha(
          theme.palette.mode === "dark"
            ? "#00c9a7"
            : theme.palette.secondary.main,
          0.05
        ),
      },
    };
  }

  return {
    ...baseStyles,
    backgroundColor:
      theme.palette.mode === "dark" ? "#00c9a7" : theme.palette.primary.main,
    color: theme.palette.mode === "dark" ? "#000" : "#fff",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha("#00c9a7", 0.9)
          : alpha(theme.palette.primary.main, 0.9),
    },
    "&.Mui-disabled": {
      backgroundColor: alpha(theme.palette.action.disabled, 0.15),
    },
  };
};

/**
 * Get error display styles
 * @param {Object} theme - MUI theme object
 * @returns {Object} Error box style object
 */
export const getErrorBoxStyles = (theme) => ({
  mt: -2,
  mb: 3,
  p: 2,
  borderRadius: 1,
  bgcolor: alpha(theme.palette.error.main, 0.1),
  border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
});
